import { ServiceFetch } from '../service-fetch'

export default class CustomerModel extends ServiceFetch {
    generateCustomerLastCode = (data) => this.authFetch({
        url: 'customer/generateCustomerLastCode',
        method: 'POST',
        body: JSON.stringify(data),
    })

    generateCustomerRegisterLastCode = (data) => this.authFetch({
        url: 'customer/generateCustomerRegisterLastCode',
        method: 'POST',
        body: JSON.stringify(data),
    })

    getCustomerBy = (data) => this.authFetch({
        url: 'customer/getCustomerBy',
        method: 'POST',
        body: JSON.stringify(data),
    })

    getCustomerRefBy = (data) => this.authFetch({
        url: 'customer/getCustomerRefBy',
        method: 'POST',
        body: JSON.stringify(data),
    })

    getCustomerByCode = (data) => this.authFetch({
        url: 'customer/getCustomerByCode',
        method: 'POST',
        body: JSON.stringify(data),
    })

    getCustomerByRegisterCode = (data) => this.authFetch({
        url: 'customer/getCustomerByRegisterCode',
        method: 'POST',
        body: JSON.stringify(data),
    })

    getCustomerByUsername = (data) => this.authFetch({
        url: 'customer/getCustomerByUsername',
        method: 'POST',
        body: JSON.stringify(data),
    })

    checkUsernameBy = (data) => this.authFetch({
        url: 'customer/checkUsernameBy',
        method: 'POST',
        body: JSON.stringify(data),
    })

    updateCustomerBy = (data) => this.authFetch({
        url: 'customer/updateCustomerBy',
        method: 'POST',
        body: JSON.stringify(data),
    })

    insertCustomer = (data) => this.authFetch({
        url: 'customer/insertCustomer',
        method: 'POST',
        body: JSON.stringify(data),
    })

    updateCustomerPointLock = (data) => this.authFetch({
        url: 'customer/updateCustomerPointLock',
        method: 'POST',
        body: JSON.stringify(data),
    })

    deleteCustomerByCode = (data) => this.authFetch({
        url: 'customer/deleteCustomerByCode',
        method: 'POST',
        body: JSON.stringify(data),
    })
}